import Header from './Header'
import Sidebar from './Sidebar'
import HttpFilter from './HttpFilter'
import AccessResult from './search/AccessResult'
import ReferenceResult from './search/ReferenceResult'
import FileWidget from './FileWidget'
import FileUpload from './FileUpload'
import TicketResult from './search/TicketResult'
import OrderEventResult from './search/OrderEventResult'

module.exports = {
  Header,
  Sidebar,
  AccessResult,
  TicketResult,
  OrderEventResult,
  ReferenceResult,
  HttpFilter,
  FileWidget,
  FileUpload
}



// WEBPACK FOOTER //
// ./src/projects/access-gui/components/core/index.js